import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';

import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Button, DialogActions, DialogContent, TextField
} from '@mui/material';

import { InterventionsService } from 'services';
import { translate } from 'utils/helpers';

import { Text } from 'components';
import { ModalHeader } from './ModalHeader';

export const UpdateInterventionNumberModal = ({
                                                onClose, onConfirm, closeOnSubmit
                                              }) => {
  const [fileNumberExist, setFileNumberExist] = useState(translate('errors.fileNumberActualExist'));
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      fileNumber: ''
    }
  });

  const onSubmit = (data) => {
    setFileNumberExist(null);
    const encodedFileNumber = encodeURIComponent(data.fileNumber);
    // Check if the fileNumber doesn't exist already
    InterventionsService.checkFileNumber(encodedFileNumber).then((response) => {
      if (response) {
        setFileNumberExist(translate('errors.fileNumberAlreadyExist'));
      } else if (response === false) {
        onConfirm(encodedFileNumber);

        if (closeOnSubmit) {
          onClose();
        }
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ModalHeader className="warningModal" onClose={onClose}>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        {translate('modalUpdateInterventionNumber.title')}
      </ModalHeader>

      <DialogContent style={{ minWidth: '600px', padding: '10px' }}>
        <Text color="var(--red)" fontWeight={600} margin="0" style={{ minHeight: '20px' }}>
          {fileNumberExist}
        </Text>
        <Controller
              control={control}
              name="fileNumber"
              render={({ field }) => (
                <TextField
                      {...field}
                      error={!!errors.fileNumber}
                      inputProps={{ maxLength: 32 }}
                      label={translate('common.cerfaNumber')}
                      required
                      style={{ width: '100%' }}
                  />
              )}
              rules={{ required: true }}
          />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{translate('button.cancel')}</Button>
        <Button color="primary" type="submit">{translate('button.save')}</Button>
      </DialogActions>
    </form>
  );
};

UpdateInterventionNumberModal.propTypes = {
  closeOnSubmit: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

UpdateInterventionNumberModal.defaultProps = {
  closeOnSubmit: true
};
